export const mockPostiesMenu = [
  {
    children: [
      {
        entityId: "515468",
        entityUuid: "4f55e50d-8d3e-438b-89a0-98e39cb9b66b",
        name: "Activity hub",
        routeType: "Section",
        urlAlias: "/posties/activity-hub",
      },
      {
        entityId: "515469",
        entityUuid: "17d39953-54c6-4613-98f4-ce9d9e2ff371",
        name: "Comics",
        routeType: "Section",
        urlAlias: "/posties/comics",
      },
      {
        entityId: "515470",
        entityUuid: "fd4a97f7-390e-422f-ac54-e238d7c8c388",
        name: "Games",
        routeType: "Section",
        urlAlias: "/posties/games",
      },
      {
        entityId: "515471",
        entityUuid: "88240256-9a35-43e8-992e-c00b3c25b1c3",
        name: "Grown-ups go here",
        routeType: "Section",
        urlAlias: "/posties/grown-ups-go-here",
      },
      {
        entityId: "515465",
        entityUuid: "4e6974ce-6968-4931-ba34-ac737a277699",
        name: "News",
        routeType: "Section",
        urlAlias: "/posties/news",
      },
      {
        entityId: "515467",
        entityUuid: "cfe74757-1c98-4ce9-9e4a-bad5b040008f",
        name: "Relax",
        routeType: "Section",
        urlAlias: "/posties/relax",
      },
      {
        entityId: "515466",
        entityUuid: "15bf8b2e-a96a-4815-9018-4ef4419170c8",
        name: "Views",
        routeType: "Section",
        urlAlias: "/posties/views",
      },
    ],
    name: "Read",
    urlAlias: "posties",
  },
  {
    name: "Video",
    urlAlias: "video/posties",
  },
  {
    name: "Epaper",
    urlAlias: "epaper",
  },
  {
    name: "Lil Journalist",
    urlAlias: "posties/events",
  },
  {
    name: "Events",
    urlAlias: "posties/events",
  },
];
